import comp from "./AddonsConfirmationModal";
export default comp;
